import Cart from 'UTILS/cart/CartObserver';

const cart = new Cart();

/* DOM nodes */
const formEl = document.querySelector('.ProductForm');
const formBtn = document.querySelector('.ProductForm-submit');
/**/

cart.subscribe('afterUpdate', () => {
  if (formBtn) formBtn.disabled = false;
});
cart.subscribe('beforeUpdate', () => {
  if (formBtn) formBtn.disabled = 'disabled';
});
cart.subscribe('error', () => {
  if (formBtn) formBtn.disabled = false;
});

if (formEl) {
  // eslint-disable-next-line func-names
  formEl.addEventListener('submit', function (e) {
    e.preventDefault();
    if (formBtn.getAttribute('aria-disabled') === 'true') return;
    const formData = new FormData(this);
    const payload = {
      id: parseInt(formData.get('id'), 10),
      quantity: parseInt(formData.get('quantity'), 10),
    };
    // TODO: ensure this works for future selling plans
    if (formData.get('selling-plan')) {
      payload.selling_plan = formData.get('selling-plan');
    }
    cart.addToCart(payload);
  });
}
